import PropTypes from 'prop-types';
import { Text, Box, Container } from 'theme-ui';
import ImgLoader from '../ImgLoader';

const Quote = ({ quote: { author, body, image } }) => {
  return (
    <Container as="section" variant="fullWidth" sx={{ backgroundColor: 'white' }}>
      <Box
        as="figure"
        sx={{
          position: 'relative',
          pt: ['4.5rem', '7.2rem', 'calc(12.7rem + 30.6rem)'],
          pb: ['8.1rem', '12.1rem', '13.7rem'],
          pl: [null, null, 'clamp(0rem, 7vw, 12rem)'],
        }}
      >
        <Text
          as="p"
          variant="text.h5"
          sx={{ display: ['none', 'block'], px: 'var(--horizontal-inset)', mb: ['2.5rem'] }}
        >
          Omorpho
        </Text>

        <Text
          as="figcaption"
          variant="h2"
          sx={{
            position: 'relative',
            fontSize: [2, '3.8rem', 4],
            px: 'var(--horizontal-inset)',
            mb: ['4.2rem', '3.8rem', '5.7rem'],
            maxWidth: ['11em', '13em'],
            zIndex: 1,
          }}
        >
          {author}
        </Text>

        {image ? (
          <Box
            sx={{
              position: [null, null, 'absolute'],
              top: '12.7rem',
              right: 'calc(var(--horizontal-inset) + clamp(0rem, 7vw, 12rem))',
            }}
          >
            <ImgLoader
              image={image}
              sx={{
                width: [null, null, '78.3rem'],
                height: ['54.6rem', '101.6rem', '103.8rem'],
                borderRadius: ['25px 0 75px', null, '50px 0 180px'],
                overflow: 'hidden',
                WebkitMaskImage: '-webkit-radial-gradient(white, black)',
              }}
            />
          </Box>
        ) : null}

        <Box
          as="blockquote"
          sx={{
            position: 'relative',
            mt: ['-12rem', '-4rem'],
            px: 'var(--horizontal-inset)',
          }}
        >
          <Text
            as="p"
            variant="text.h1"
            sx={{ fontSize: ['clamp(5rem, 14vw, 5.4rem)', '7.8rem', '12rem'], maxWidth: [null, '56rem', '90rem'] }}
          >
            “{body.text}”
          </Text>
        </Box>
      </Box>
    </Container>
  );
};

Quote.propTypes = {
  quote: PropTypes.shape({
    id: PropTypes.string.isRequired,
    author: PropTypes.string.isRequired,
    body: PropTypes.shape({
      text: PropTypes.string.isRequired,
    }).isRequired,
    image: PropTypes.shape({
      fluid: PropTypes.object.isRequired,
    }),
  }),
};

export default Quote;
